export default __webpack_public_path__ + "static/media/file_loader.31932444.svg";